import React, { useState, useContext, useEffect } from "react";
import Swal from "sweetalert2";
import { UrlContext } from "../../contexts/UrlContext";

const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const years = Array.from({ length: 50 }, (_, i) => new Date().getFullYear() - i);

export function ModifyAward({ expertID, selectedAward, getExpertAwards, onCancel }) {
  const { API_URL } = useContext(UrlContext);
  const [awardName, setAwardName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  useEffect(() => {
    if (selectedAward) {
      setAwardName(selectedAward.awardName || "");

      const parts = selectedAward.awardDate?.split("·") || [];
      const issuedBy = parts[0]?.replace("Issued by", "").trim();
      const datePart = parts[1]?.trim();

      if (issuedBy) setCompanyName(issuedBy);
      if (datePart) {
        const [m, y] = datePart.split(" ");
        setMonth(m);
        setYear(y);
      }
    }
  }, [selectedAward]);

  const modifyExpertAwards = async (expertAward) => {
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value || localStorage.getItem("AccessToken");
    const requestBody = {
      expertID: expertID,
      awardID: selectedAward.awardID,
      award: expertAward,
    };
      
    try {
      let modifiedUrl = "modify-eph-award-data";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      
      const responseData = await response.json();
      if (responseData.status === "success") {
        getExpertAwards();
        Swal.fire({title: "Success!", text: responseData.text, icon: "success", showConfirmButton: false, timer: 2000});
      } else if (responseData.status === "error") {
        Swal.fire({ title: "Error!", text: responseData.text, icon: "error", confirmButtonColor: "#365565"});
      } else {
        Swal.fire({ title: "Error!", text: "Failed to modify award!", icon: "error", confirmButtonColor: "#365565"});
      }
    } catch (error) {
      Swal.fire({title: "Error!", text: error,  icon: "error", confirmButtonColor: "#365565"});
    }
  };

  const deleteExpertAwards = async () => {
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value || localStorage.getItem("AccessToken");
    const requestBody = {
      awardID: selectedAward.awardID,
    };
      
    try {
      let modifiedUrl = "delete-eph-award-data";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      
      const responseData = await response.json();
      if (responseData.status === "success") {
        getExpertAwards();
        Swal.fire({title: "Success!", text: responseData.text, icon: "success", showConfirmButton: false, timer: 1500});
      } else if (responseData.status === "error") {
        Swal.fire({ title: "Error!", text: responseData.text, icon: "error", confirmButtonColor: "#365565"});
      } else {
        Swal.fire({ title: "Error!", text: "Failed to delete award!", icon: "error", confirmButtonColor: "#365565"});
      }
    } catch (error) {
      Swal.fire({title: "Error!", text: error,  icon: "error", confirmButtonColor: "#365565"});
    }
  };

  const handleSave = async () => {
    if (!awardName || !companyName || !month || !year) {
      alert("Please fill all fields.");
      return;
    }

    const updatedAward = {
      awardName,
      awardDate: `Issued by ${companyName} · ${month} ${year}`
    };

    await modifyExpertAwards(updatedAward);
    onCancel();
  };

  const handleDelete = async () => {
    await deleteExpertAwards();
    onCancel();
  };

  return (
    <div className="flex flex-col gap-2">
      <input
        className="w-full border-b border-gray-300 hover:border-[#365561] focus:border-[#365561] focus:outline-none text-sm pb-0.1"
        placeholder="Award Name"
        value={awardName}
        onChange={(e) => setAwardName(e.target.value)}
      />
      <input
        className="w-full border-b border-gray-300 hover:border-[#365561] focus:border-[#365561] focus:outline-none text-sm pb-0.1"
        placeholder="Awarded By"
        value={companyName}
        onChange={(e) => setCompanyName(e.target.value)}
      />
      <div className="flex gap-2">
        <select
          className="border-b border-gray-300 hover:border-[#365561] focus:border-[#365561] focus:outline-none text-sm pb-0.1 bg-transparent"
          value={month}
          onChange={(e) => setMonth(e.target.value)}
        >
          <option value="">Month</option>
          {months.map(m => <option key={m} value={m}>{m}</option>)}
        </select>
        <select
          className="border-b border-gray-300 hover:border-[#365561] focus:border-[#365561] focus:outline-none text-sm pb-0.1 bg-transparent"
          value={year}
          onChange={(e) => setYear(e.target.value)}
        >
          <option value="">Year</option>
          {years.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>

      <div className="flex justify-end gap-4 mt-6">
        <button
          onClick={handleDelete}
          className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700"
        >
          Delete
        </button>
        <button
          onClick={handleSave}
          className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700"
        >
          Save
        </button>
      </div>
    </div>
  );
}